import React from 'react';

import Icon from './Icon';
import { IconProps } from './types';

const CloseIcon = (props: IconProps) => <Icon {...props} src="/icons/close.svg" />;

export default CloseIcon;
